<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

const elementCount = ref(0);
let debounceTimer: number | null = null;
let observer: MutationObserver | null = null;

const colorClass = computed(() => {
  const count = elementCount.value;

  if (count > 2000) {
    return "bg-red-600"; // Very high - red
  } else if (count > 1000) {
    return "bg-orange-500"; // High - orange
  } else if (count > 500) {
    return "bg-yellow-500"; // Medium - yellow
  } else {
    return "bg-green-600"; // Low - green
  }
});

const updateCount = () => {
  elementCount.value = document.getElementsByTagName("*").length;
};

const debouncedUpdate = () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = window.setTimeout(updateCount, 100);
};

onMounted(() => {
  // Initial count
  updateCount();

  // Watch for DOM changes with MutationObserver
  observer = new MutationObserver(debouncedUpdate);
  observer.observe(document.body, {
    childList: true, // Watch for added/removed nodes
    subtree: true, // Watch entire DOM tree
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
});
</script>

<template>
  <div
    class="fixed bottom-4 right-4 rounded px-4 py-2 font-bold text-white shadow-lg z-[9999]"
    :class="colorClass"
  >
    <div class="text-xs opacity-75">DOM Elements</div>
    <div class="text-2xl">{{ elementCount }}</div>
  </div>
</template>
